import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const currentYear = new Date().getFullYear();
  return <>
      <footer className="py-12 text-center text-[#7a5568] text-sm border-t border-[#f0d0dc] bg-[#FFF5F7]" data-id="element-62">
        <div className="max-w-4xl mx-auto px-4" data-id="element-63">
          <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-6" data-id="element-64">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-[#c4607a] transition-colors underline decoration-[#c4607a]/30 hover:decoration-[#c4607a] underline-offset-4" data-id="element-65">
              Política de Privacidad
            </button>
            <span className="hidden md:inline text-[#f0d0dc]" data-id="element-66">•</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-[#c4607a] transition-colors underline decoration-[#c4607a]/30 hover:decoration-[#c4607a] underline-offset-4" data-id="element-67">
              Términos y Condiciones
            </button>
          </div>

          <p className="opacity-60 font-serif" data-id="element-68">
            © {currentYear} Lo Estás Haciendo Bien. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-69">
        <div className="space-y-4" data-id="element-70">
          <p data-id="element-71">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

          <h3 className="text-xl font-bold mt-6 mb-2 font-serif text-[#c4607a]" data-id="element-72">
            1. Introducción
          </h3>
          <p data-id="element-73">
            En "Lo Estás Haciendo Bien", nos comprometemos a proteger su
            privacidad. Esta política explica cómo recopilamos, usamos y
            protegemos su información personal cuando visita nuestro sitio web.
          </p>

          <h3 className="text-xl font-bold mt-6 mb-2 font-serif text-[#c4607a]" data-id="element-74">
            2. Recopilación de Información
          </h3>
          <p data-id="element-75">
            Podemos recopilar información que usted nos proporciona
            voluntariamente, como su nombre y dirección de correo electrónico
            cuando se suscribe a nuestro boletín o descarga nuestros recursos.
          </p>

          <h3 className="text-xl font-bold mt-6 mb-2 font-serif text-[#c4607a]" data-id="element-76">
            3. Uso de la Información
          </h3>
          <p data-id="element-77">Utilizamos su información para:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-78">
            <li data-id="element-79">Proporcionar y mantener nuestro servicio.</li>
            <li data-id="element-80">Notificarle sobre cambios en nuestro servicio.</li>
            <li data-id="element-81">Proporcionar soporte al cliente.</li>
            <li data-id="element-82">
              Recopilar análisis o información valiosa para mejorar nuestro
              servicio.
            </li>
          </ul>

          <h3 className="text-xl font-bold mt-6 mb-2 font-serif text-[#c4607a]" data-id="element-83">
            4. Cookies
          </h3>
          <p data-id="element-84">
            Utilizamos cookies y tecnologías de seguimiento similares para
            rastrear la actividad en nuestro servicio y mantener cierta
            información.
          </p>

          <h3 className="text-xl font-bold mt-6 mb-2 font-serif text-[#c4607a]" data-id="element-85">
            5. Seguridad de los Datos
          </h3>
          <p data-id="element-86">
            La seguridad de sus datos es importante para nosotros, pero recuerde
            que ningún método de transmisión por Internet o método de
            almacenamiento electrónico es 100% seguro.
          </p>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-87">
        <div className="space-y-4" data-id="element-88">
          <p data-id="element-89">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

          <h3 className="text-xl font-bold mt-6 mb-2 font-serif text-[#c4607a]" data-id="element-90">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-91">
            Al acceder y utilizar este sitio web, usted acepta estar sujeto a
            estos Términos y Condiciones y a todas las leyes y regulaciones
            aplicables.
          </p>

          <h3 className="text-xl font-bold mt-6 mb-2 font-serif text-[#c4607a]" data-id="element-92">
            2. Propiedad Intelectual
          </h3>
          <p data-id="element-93">
            El contenido, diseño y gráficos de este sitio web están protegidos
            por derechos de autor y otras leyes de propiedad intelectual. No
            puede reproducir, distribuir o crear trabajos derivados sin nuestro
            permiso expreso.
          </p>

          <h3 className="text-xl font-bold mt-6 mb-2 font-serif text-[#c4607a]" data-id="element-94">
            3. Uso del Sitio
          </h3>
          <p data-id="element-95">
            Se le concede una licencia limitada para acceder y hacer uso
            personal de este sitio. No está permitido descargar (excepto el
            almacenamiento en caché de páginas) o modificar cualquier parte del
            mismo sin nuestro consentimiento por escrito.
          </p>

          <h3 className="text-xl font-bold mt-6 mb-2 font-serif text-[#c4607a]" data-id="element-96">
            4. Limitación de Responsabilidad
          </h3>
          <p data-id="element-97">
            En ningún caso "Lo Estás Haciendo Bien" será responsable de daños
            directos, indirectos, incidentales o consecuentes que surjan del uso
            o la imposibilidad de uso de nuestros materiales.
          </p>

          <h3 className="text-xl font-bold mt-6 mb-2 font-serif text-[#c4607a]" data-id="element-98">
            5. Modificaciones
          </h3>
          <p data-id="element-99">
            Nos reservamos el derecho de revisar estos términos de servicio en
            cualquier momento sin previo aviso. Al utilizar este sitio web,
            usted acepta estar sujeto a la versión actual de estos términos.
          </p>
        </div>
      </Modal>
    </>;
}